var React = require('react');

function Crop (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"fill":"currentColor","d":"M4.664 11.333V.667H3.331v2.666H.664v1.334h2.667v6.666a1.333 1.333 0 0 0 1.333 1.334h6.667v2.666h1.333v-2.666h2.667v-1.334m-4-1.333h1.333V4.667c0-.74-.6-1.334-1.333-1.334H5.997v1.334h5.334V10Z"})));
}

Crop.defaultProps = {"fill":"none","viewBox":"0 0 16 16"};

module.exports = Crop;

Crop.default = Crop;
